import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {CasablancaConfig} from "crqlar-react-common/dist/models/integrations/casablanca/casablancaConfig.model";
import {CasablancaService} from "crqlar-react-common/dist/services/integrations/casablanca/casablanca.service";
import StatsImportLogsTable from "../../common/StatsImportLogsTable";

interface Props {
    casablancaConfigData: UseEntityData<CasablancaConfig>
}

const Logs = ({casablancaConfigData}: Props) => (
    <StatsImportLogsTable
        configId={casablancaConfigData.item.id}
        getStats={CasablancaService.getStats}
        connectorId="casablanca"
    />
);

export default Logs;
